<template>
    <rkm-modal
        ref="modal"
        @save="handleSave"
        large
        title="Incluir laudo"
        :buttons="['cancel', 'save']"
    >
        <rkm-row class="flex">
            <rkm-col class="flex-grow-1">
                <rkm-form-file
                    label="Laudos"
                    multiple
                    v-model="model.filesSelected"
                    type="file"
                    placeholder="SELECIONE UM LAUDO"
                    accept=".pdf"
                    browse-text="Selecionar"
                    drop-placeholder="Arraste e solte aqui..."
                    ref="file-input"
                >
                    Pesquisar
                </rkm-form-file>
            </rkm-col>

            <rkm-col class="flex-grow-0">
                <rkm-button
                    @click.stop="addLaudos()"
                    color="primary"
                    ref="file-input"
                    :label="false"
                >
                    Incluir
                </rkm-button>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-table
                    :fields="fields"
                    :items="model.files"
                    class="mt-2"
                    tag="div"
                    hide-pagination
                    hide-filters
                >
                    <template v-slot:cell(actions)="{ index }">
                        <rkm-button
                            @click.stop="checkLaudo(index)"
                            color="primary"
                            small
                            title="Visualizar"
                        >
                            <rkm-icon icon="download" />
                        </rkm-button>

                        <rkm-button
                            color="danger"
                            @click="removeLaudo(index)"
                            small
                            title="Excluir"
                        >
                            <rkm-icon icon="trash" />
                        </rkm-button>
                    </template>
                </rkm-table>
            </rkm-col>
        </rkm-row>
    </rkm-modal>
</template>

<script>
export default {
    data: () => ({
        model: {
            index: null,
            files: [],
            filesSelected: []
        },
        form: null,
        fields: [
            { key: 'name', label: 'Laudos', class: 'align-middle' },
            { key: 'actions', label: 'Ações', class: 'col-min' }
        ],
    }),
    methods: {
        addLaudos(){
            this.model.files = this.model.files.concat(this.model.filesSelected)
            this.model.filesSelected = []
        },
        checkLaudo(laudo){
            window.open(URL.createObjectURL(this.model.files[laudo]), '_blank')
        },
        open(index) {
            this.model.index = index
            this.$refs.modal.show()
        },
        handleSave() {
            this.$emit('updateLaudo', this.model)
            this.$refs.modal.hide()
        },
        removeLaudo(index) {

            const destroy = async () => this.model.files.splice(index, 1)

            this.showDeleteConfirmation('Deseja realmente excluir o laudo?', destroy)
        },
        preparaObservacao() {
            let observacao = JSON.parse(JSON.stringify(this.model))
            return observacao
        },
        exit() {
            this.$refs.modal.hide()
        },
    },
}
</script>